import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
import moment from "moment";
import { Core } from "../helpers/core";
import { Money } from "../helpers/money";
import { AppIcons } from "../constants/app-icons";
import { DOMAIN } from "./domain-constant";
import { confirmTbaApproval } from "../helpers/tba-approval.js";
const tbaApprove = (context, selectedItems) =>
  confirmTbaApproval(context, "approve", context.service, selectedItems);
const tbaReject = (context, selectedItems) =>
  confirmTbaApproval(context, "reject", context.service, selectedItems);

export default class InvoiceService extends ApiService {
  namespace = "invoice";
  template = "defaultTemplate";
  fullWindow = false;
  icon = "transparrentinvoice";
  enableSchedular = true;
  relations =
    "?expand=lineItems,layout,writeoffs,overPayments,headers,footers,messages,journals,overPayments,files,files.file,files.file.commentsCount,customerName,salesRep,warehouse";
  listingRelations = "customerName";
  customer = "";
  DOMAIN = DOMAIN.INVOICE;
  search = true;
  data = [];
  showLeftBar = false;
  favicon = "Invoice";
  useNextNumber = true;
  singular = this.terminology.invoice.singular;
  plural = this.terminology.invoice.plural;
  vowel = this.terminology.invoice.vowel;
  name = this.terminology.invoice.plural;
  labelKey = "number";
  Width = 1300;
  gemItems = [
    {
      key: "listing",
      label: this.name,
      icon: AppIcons.BULLETS,
    },
    {
      key: "create",
      label: "Add an Invoice",
      icon: AppIcons.PLUS,
    },
    {
      key: "listing",
      label: `Invoices Waiting for Approval`,
      icon: AppIcons.DOCUMENT,
    },
    {
      key: "create",
      label: "Settings",
      services: DOMAIN.INVOICE_SETTING,
      icon: AppIcons.GEAR,
    },
    {
      key: "create",
      label: this.t("addAnEntity", {
        entity: this.terminology.invoiceBuilder.singular,
      }),
      icon: AppIcons.PLUS,
      services: DOMAIN.INVOICE_BUILDER,
    },
    {
      key: "listing",
      label: this.t("allEntity", {
        entity: this.terminology.invoiceBuilder.plural,
      }),
      icon: AppIcons.BULLETS,
      services: DOMAIN.INVOICE_BUILDER,
    },
    {
      key: "create",
      label: this.t("Add an Automated Tasks", {
        entity: this.terminology.task.singular,
      }),
      icon: AppIcons.PLUS,
      services: DOMAIN.AUTOMATED_TASK,
    },
    {
      key: "listing",
      label: this.t("All Automated Tasks", {
        entity: this.terminology.task.plural,
      }),
      icon: AppIcons.BULLETS,
      services: DOMAIN.AUTOMATED_TASK,
    },
  ];
  columns = [
    {
      header: this.t("number"),
      icon: AppIcons.SHRED,
      field: "number",
      sortable: true,
    },
    {
      header: this.t("customer"),
      icon: AppIcons.USER_SILHOUETTE,
      field: "customer",
      name3: "wqeqwe",
      template: (data) =>
        data.customer?.display_name ?? data.customerName ?? "",
    },
    {
      header: this.t("date"),
      icon: AppIcons.GREEN_CALENDAR,
      field: "date",
      sortable: true,
      template: (data) => {
        return Core.datey(data.date);
      },
    },
    {
      header: this.t("due"),
      icon: AppIcons.CALENDAR,
      field: "due_date",
      sortable: true,
      template: (data) => {
        return moment(String(data.due_date)).format("MM/DD/YYYY");
      },
    },
    {
      header: this.t("amount"),
      icon: AppIcons.MONEY,
      field: "total_amount",
      sortable: true,
      template: (data) => {
        return Money.format(data.total_amount);
      },
    },
    {
      header: this.t("received"),
      icon: AppIcons.MONEY,
      field: "total_paid",
      width: "3",
      sortable: true,
      template: (data) => {
        let total_paid = 0;
        return Money.format(data.total_paid || total_paid);
      },
    },
    {
      header: this.t("balance"),
      icon: AppIcons.MONEY,
      field: "balance_due",
      width: "3",
      sortable: true,
      template: (data) => {
        let balance_due = 0;
        return Money.format(data.balance_due || balance_due);
      },
    },
    {
      header: this.t("status"),
      icon: AppIcons.LIGHTNING,
      field: "status",
      width: "3",
      statusIndicator: true,
    },

    {
      field: "writeoff",
      width: "5",
      icons: [
        { icon: AppIcons.PEN, tooltip: "Write Off" },
        { icon: AppIcons.CREDIT_CARD_GREEN, tooltip: "Credit Memo" },
      ],
      iconCells: (data) => {
        const cells = [];
        const writtenOff = Number(data.total_written_off) || 0;
        if (writtenOff > 0) {
          cells.push({
            icon: AppIcons.PEN,
            tooltip: `Write Off: ${Money.format(writtenOff)}`,
          });
        }
        const creditApplied = Number(data.total_credit_applied) || 0;
        if (creditApplied > 0) {
          cells.push({
            icon: AppIcons.CREDIT_CARD_GREEN,
            tooltip: `Credit Applied: ${Money.format(creditApplied)}`,
          });
        }
        return cells;
      },
    },
  ];
  lineItems = [
    {
      key: "edit",
      label: "Apply Subtotal",
      icon: PrimeIcons.PENCIL,
    },
    {
      key: "announce",
      label: "Bank Line",

      icon: PrimeIcons.LIST,
    },
    {
      key: "email",
      label: "Discount",
      icon: PrimeIcons.ENVELOPE,
    },
    {
      key: "bookmark",
      label: "Good",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Inventory Item",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Other Change",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Over Payment",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Service",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Tax",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      separator: true,
    },
    {
      key: "inactive",
      label: "Time & Expenses",
      icon: PrimeIcons.LOCK,
    },
  ];
  moreItems = [
    {
      key: "more-load-template",
      label: "Load template",
      icon: AppIcons.FOLDER,
      type: "1",
    },
    {
      key: "more-save-preview",
      label: "Save and preview",
      icon: AppIcons.PREVIEW,
      type: "2",
    },
    {
      key: "more-save-print",
      label: "Save and print",
      icon: AppIcons.PRINTER,
      type: "3",
    },
    {
      key: "more-save-email",
      label: "Save and e-mail",
      icon: AppIcons.MAIL,
      type: "4",
    },
    {
      key: "more-manage-layout",
      label: "Manage layout",
      icon: AppIcons.LAYOUT,
      type: "5",
    },
  ];
  navItems = [
    {
      key: "listing",
      label: this.t("viewAllEntities", { entity: this.plural }),
      icon: AppIcons.LIST,
    },
    {
      key: "bookmark",
      label: this.t("viewMyBookmarks", { entity: this.singular }),
      icon: AppIcons.BOOKMARK,
    },
    {
      key: "inactive",
      label: this.t("viewInactiveEntity", { entity: this.plural }),
      services: DOMAIN.VENDOR,
      icon: AppIcons.DISABLE,
    },
  ];
  getActionMenu(item) {
    const entity = this.singular;
    return [
      {
        key: "detail",
        label: this.t("previewThisEntity", { entity }),
        icon: "Eye",
      },
      {
        key: "edit",
        label: this.t("editThisEntity", { entity }),
        icon: "edit",
      },
      {
        key: "announce",
        label: this.t("announceThisEntity", { entity }),
        services: DOMAIN.MESSAGES,
        icon: AppIcons.ANNOUNCEMENT,
      },
      {
        key: "email",
        label: this.t("emailThisEntity", { entity }),
        icon: AppIcons.MAIL,
        services: DOMAIN.EMAIL,
      },
      {
        key: "bookmark",
        label: this.t("bookmarkThisEntity", { entity }),
        icon: AppIcons.BOOKMARK,
      },
    ];
  }
  listMenuItems = [
    {
      key: "transaction",
      label: this.t("transactionSummary"),
      icon: AppIcons.DOLLAR,
    },
    {
      key: "create",
      label: this.t("copyThisEntity", { entity: this.singular }),
      icon: AppIcons.COPY,
      serviceId: DOMAIN.COPY_PAYABLES,
    },
    {
      key: "create",
      label: this.t("writingOffAnInvoice"),
      icon: AppIcons.PEN,
      serviceId: DOMAIN.INVOICE_WRITE_OFF,
      visible: (item) => {
        if (Number(item?.is_draft) === 1 || Number(item?.is_template) === 1) {
          return false;
        }
        const raw = item?.balance_due ?? item?.remaining;
        let balance = 0;
        if (raw != null && raw !== "" && !Number.isNaN(Number(raw))) {
          balance = Number(raw);
        } else {
          balance =
            (Number(item?.total_amount) || 0) -
            (Number(item?.total_paid) || 0);
        }
        return balance > 0;
      },
    },
    {
      key: "exec",
      label: this.t("printThisEntity", { entity: this.singular }),
      icon: AppIcons.PRINTER,
      action: (item, ctx) => {
        ctx.$emit("print", item);
      },
    },
    {
      key: "email",
      label: this.t("emailThisEntity", { entity: this.singular }),
      services: DOMAIN.EMAIL,
      icon: AppIcons.MAIL,
    },
    {
      key: "viewJournal",
      label: this.t("viewJournal"),
      icon: AppIcons.JOURNAL_VIEW,
    },
    // {
    //   key: "create",
    //   label: "Secure",
    //   icon: AppIcons.LOCK2,
    //   serviceId: DOMAIN.SECURE_ITEM,
    // },
    // {
    //   key: "exec",
    //   label: "Convert into Invoice",
    //   icon: AppIcons.COPY,
    //   action: (item, ctx) => {
    //     ctx.emitter.emit("open-gem", {
    //       item: {
    //         key: "convert",
    //         label: "Convert into Invoice",
    //         isVisible: true,
    //         service: 157,
    //         item: item,
    //       },
    //     });
    //   },
    //   reject: () => {},
    // },
  ];
  displayJournal = (key, item) => {
    // this.context.emitter.emit("open-gem", {
    //   item: {
    //     key: event.item.key,
    //     label: event.item.label,
    //     isVisible: true,
    //     service: this,
    //     item: this.currentItem,
    //   },
    // });
  };
  filterItems = [
    { name: "Status", key: "status", value: "2", realm: "2" },
    { name: "Date", key: "date", value: "3", realm: "1" },
    { name: "Due Date", key: "due", value: "4", realm: "0" },
  ];
  gemMenuItems = [
    {
      key: "create",
      label: "Add a Invoice",
      icon: PrimeIcons.LIST,
    },
  ];
  permissions = [
    {
      key: "is_template",
      display_name: "Template",
      icon: AppIcons.TEMPLATE,
      value: 1,
    },
    {
      key: "is_draft",
      display_name: "Draft",
      icon: AppIcons.DOCUMENT_WITH_TEXT,
      value: 1,
    },

    {
      key: "is_tba",
      display_name: "Waiting Approval",
      icon: AppIcons.TICK,
      value: 1,
    },
    {
      key: "is_approved",
      display_name: "Open",
      icon: AppIcons.NOTEBOOK,
      value: 1,
    },
    {
      key: "status",
      display_name: "Complete",
      icon: AppIcons.MONEY,
      value: 1,
    },
    {
      key: "is_in_print_que",
      display_name: "Print Que",
      icon: AppIcons.FAX,
      value: 1,
    },
    {
      key: "is_in_email_que",
      display_name: "Email Que",
      icon: AppIcons.MAIL,
      value: 1,
    },
    {
      key: "saleorder",
      display_name: "Wrife Off",
      icon: AppIcons.PEN,
      value: 1,
    },
    {
      key: "is_recurring",
      display_name: "Recurring Billing",
      icon: AppIcons.BILLABLE,
      value: 1,
    },
  ];
  listingControls = [
    {
      key: "approve_all",
      label: "Approve All",
      icon: AppIcons.CIRCLE_WITH_CHECK_MARK,
      displayTotalItems: true,
      action: tbaApprove,
    },
    {
      key: "reject_all",
      label: "Reject All",
      icon: AppIcons.CIRCLE_WITH_X,
      displayTotalItems: true,
      action: tbaReject,
    },
    {
      key: "approve",
      label: "Approve ",
      icon: AppIcons.CIRCLE_WITH_CHECK_MARK,
      action: tbaApprove,
    },
    {
      key: "reject",
      label: "Reject ",
      icon: AppIcons.CIRCLE_WITH_X,
      action: tbaReject,
    },
  ];
  // loadJournal(id) {
  //   let moduleNode = "/" + id;
  //   moduleNode += "?expand=journals,journals.accounts,journals.entityLabel";

  //   return this.get({}, `${moduleNode}`).then((res) => res);
  // }

  loadTBAInvoices() {
    return this.count({ is_tba: 1, sort: "-id" });
  }

  constructor() {
    super("invoices");
  }
}
